import { useEffect, useState } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
// @mui
import { Alert, Box, Button, Grid } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import { useSettingsContext } from '../../components/settings';
//
import Main from './Main';
import Header from './header';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import NavHorizontal from './nav/NavHorizontal';
import BottomNavigationButtons from './bottom-navigation';
import { useAuthContext } from 'src/auth/hooks';
import { ROLES } from 'src/utils/constants/constants';
import { dispatch } from 'src/redux/store';
import { routePrefix } from 'src/utils/methods/StandardMethods';
import { fetchCardByCustomerId } from 'src/redux/slices/card';
import PaymentNewCardDialog from 'src/pages/billing/PaymentNewCardDialog';
import { useLocales } from 'src/locales';

// ----------------------------------------------------------------------

const RenderSwitch = (role: string, navigate: any, orgCode?: string, user?: any) => {

  switch (role) {
    case ROLES.SUPER_ADMIN:
    case ROLES.SITE_ADMIN:

      if (orgCode === 'admin') {
        return true
      } else {
        return navigate('404');
      }
    // if (orgCode === 'admin') {
    //   return true
    // } else {
    //   return navigate('404');
    // }
    case ROLES.ORG_ADMIN:
      if (orgCode === user?.organization?.orgCode) {
        return true
      } else {
        return navigate('404');
      }
    case ROLES.ORG_USER:
      if (orgCode === user?.organization?.orgCode) {
        return true
      } else {
        return navigate('404');
      }
    case ROLES.INDIVIDUAL_USER:
      if (orgCode) {
        return navigate('404');
      } else {
        return true;
      }
    default:
      return navigate('login');
  }

}

export default function DashboardLayout() {
  const { themeLayout } = useSettingsContext();

  const { orgCode } = useParams();

  const navigate =  useNavigate();

  const { user, updateMyProfile } = useAuthContext();

  const [fillBillingDetails, setFillBillingDetails] = useState(false);

  const [checkBillingDetails, setCheckBillingDetails] = useState(true);

  const isDesktop = useResponsive('up', 'lg');
  useEffect(() => {
    console.log(user);
    console.log('I am called');
    RenderSwitch(user?.role.name, navigate, orgCode, user)
  }, [orgCode, user, navigate])

  const { translate } = useLocales();

  const [open, setOpen] = useState(false);

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {

    const orgCode = routePrefix(user);
    (user?.role?.name === ROLES.ORG_ADMIN || user?.role?.name === ROLES.INDIVIDUAL_USER) && dispatch(fetchCardByCustomerId(user?.customerId, orgCode))
      .then((res) => {
        if (res?.card?.cardId) {
          setCheckBillingDetails(true);
        } else {
          setCheckBillingDetails(false);
        }
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fillBillingDetails])

  const handleCloseBillingDialog = () => {
    setFillBillingDetails(false);
    updateMyProfile(user?.id);
  }


  const billingAlert = () => {

    console.log('checkBillingDetails', checkBillingDetails)
    return (
      (user?.role?.name === ROLES.ORG_ADMIN || user?.role?.name === ROLES.INDIVIDUAL_USER)
      && user?.organization?.isPaymentInfoRequired
      && !checkBillingDetails
      && <Grid item xs={12} sx={{ mb: '15px' }}>
        <Alert
          severity="error"
          action={
            <Button
              size='small'
              variant='outlined'
              sx={{ color: 'black' }}
              onClick={() => setFillBillingDetails(true)}
            >
              {translate("Fill Now")}
            </Button>
          }
        >
          {translate("Please fill your billing details!")}
        </Alert>
      </Grid>
    )
  }
  const renderNavVertical = <NavVertical openNav={open} onCloseNav={handleClose} />;

  if (isNavHorizontal) {
    return (
      <>
        <Header onOpenNav={handleOpen} attechLogo={true} />

        {isDesktop ? <NavHorizontal /> : renderNavVertical}
        <Main>
          {/* {billingAlert()} */}

          <Outlet />
        </Main>
        {isDesktop ? <></> : <BottomNavigationButtons onOpenNav={handleOpen} />}

        <PaymentNewCardDialog open={fillBillingDetails} onClose={handleCloseBillingDialog} />

      </>
    );
  }

  if (isNavMini) {
    return (
      <>
        <Header onOpenNav={handleOpen} attechLogo={!isDesktop && true} />

        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          {isDesktop ? <NavMini /> : renderNavVertical}

          <Main>
            {/* {billingAlert()} */}

            <Outlet />
          </Main>
          <PaymentNewCardDialog open={fillBillingDetails} onClose={handleCloseBillingDialog} />

        </Box>

        {isDesktop ? <></> : <BottomNavigationButtons onOpenNav={handleOpen} />}
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={handleOpen} attechLogo={!isDesktop && true} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main>
          {/* {billingAlert()} */}

          <Outlet />
        </Main>
        <PaymentNewCardDialog open={fillBillingDetails} onClose={handleCloseBillingDialog} />

      </Box>

      {isDesktop ? <></> : <BottomNavigationButtons onOpenNav={handleOpen} />}
    </>
  );
}
